
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { HistoryPackageItem } from '@/features/shipment-history/types';
import StatusMarkMixin from '@/features/common/mixins/statusMarkMixin';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';

@Component
export default class TrackingNumber extends Mixins(StatusMarkMixin, ResponsivenessMixin) {
  @Prop({ required: true }) item!: HistoryPackageItem;

  @Prop({ default: '' }) status!: string;
}
